import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OtpModel } from 'common/models/page-models/Login/Otp/otp-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { OtpFormWidgetService } from 'common/widget/login/otp-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class OtpFormResolver extends FormResolverService<OtpModel> {
    constructor(
        protected fs: OtpFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
       
    }

    override modifyResponseData(dataModel, meta, widget) {
        dataModel['email'] = widget.transferData.email;
        return dataModel;
    }
}

